import css from "styled-jsx/css";
import getColor, { COLOR_DICTIONARY } from "@gc-npm/utils.enums.colors";

export default css`
  .alert {
    display: flex;
    align-items: center;
    background-color: ${getColor(COLOR_DICTIONARY.GREY_100)};
    border-radius: 10px;
    padding: 10px;
    &.justify-content-center {
      justify-content: center;
    }
    .icon-container {
      margin-right: 0.5rem;
      .icon {
        display: flex;
        align-items: center;
        justify-content:center;
        height: 35px;
        width: 35px;
        border-radius: 50%;
        margin-right: 0.5rem;
      }
      .background {
        background-color: white;
      }
    }
    .image {
      width: 20px;
      margin-right: 20px;
    }
  }
`;
